import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-divorce',
  templateUrl: './divorce.component.html',
  styleUrls: ['./divorce.component.css']
})
export class DivorceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
